import React from 'react';

const FileUploader = ({ controller }) => <input type="file" ref={controller.onInputRef} hidden />;

export default FileUploader;
